const snack = require("../../../../../components/snack/snack");
const transactionApOne = require("../transaction/transaction-report-account-payable");
const transactionApAll = require("../transaction/transaction-report-account-payable-all");

const showError = (id = "downloadError") => snack.start({ act: "show", id });

function hubDetail() {
  return {
    reportPageRightId: "reportHub-report-output",
    skipReportPage: true,
    entity: "transaction",
  };
}

export function getData(def, filters) {
  const actions = {
    "transaction-payable-one": () => {
      if (!filters.entityId) return showError();
      transactionApOne.start({
        ...hubDetail(),
        source: "hub",
        dbid: filters.entityId,
      });
    },
    "transaction-payable-all": () => {
      transactionApAll.start({
        ...hubDetail(),
      });
    },
  };

  const action = actions[def.id];
  action ? action() : showError();
}
